<div class="login-shell">
  <div class="login-orb login-orb-1"></div>
  <div class="login-orb login-orb-2"></div>
  <div class="login-orb login-orb-3"></div>

  <div class="login-panel">
    <div class="brand-badge">
      <i class="fa fa-industry"></i>
    </div>
    <h1>Production Tracker</h1>
    <div class="tagline-divider"></div>
    <p class="tagline">Manufacturing Production Tracking System</p>

    <div class="feature-carousel">
      <div class="feature-slides">
        <div class="feature-slide" *ngFor="let feature of features; let i = index" [class.active]="i === activeFeature">
          <div class="feature-icon"><i class="fa" [ngClass]="feature.icon"></i></div>
          <div class="feature-title">{{ feature.title }}</div>
          <div class="feature-description">{{ feature.description }}</div>
        </div>
      </div>
      <div class="feature-dots">
        <button
          type="button"
          *ngFor="let feature of features; let i = index"
          class="feature-dot"
          [class.active]="i === activeFeature"
          [attr.aria-label]="'Show feature: ' + feature.title"
          (click)="selectFeature(i)"
        ></button>
      </div>
    </div>
  </div>

  <div class="login-card">
    <h4 class="sign-in-text">Sign In</h4>
    <form #loginForm="ngForm" (ngSubmit)="login()">
      <div class="error-banner" *ngIf="errorMessage">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <div class="form-group mb-3">
        <label class="label-form">Login ID</label>
        <div class="input-shell">
          <i class="fa fa-user"></i>
          <input class="form-control" type="text" name="Lid" placeholder="e.g. admin" [(ngModel)]="loginId" required autocomplete="username" />
        </div>
      </div>
      <div class="form-group mb-3">
        <label class="label-form">Password</label>
        <div class="input-shell">
          <i class="fa fa-lock"></i>
          <input
            class="form-control"
            [type]="showPassword ? 'text' : 'password'"
            name="pw"
            placeholder="••••••••"
            [(ngModel)]="password"
            required
            autocomplete="current-password"
          />
          <button
            type="button"
            class="password-toggle"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            (click)="showPassword = !showPassword"
          >
            <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
          </button>
        </div>
      </div>
      <div class="form-group mb-0">
        <button class="btn btn-primary btn-login btn-block" type="submit" [disabled]="loginForm.invalid">
          Sign In
        </button>
      </div>
    </form>
  </div>

  <div class="login-footer">Powered by Viotal Works &middot; &copy; {{ currentYear }} Viotal Works. All rights reserved.</div>
</div>
